
const quoteItemApi = {

    async getQuoteItem(quoteId, quoteItemId){
        const results = await fetch(window.location.origin + '/api/v1/configurator/quotes/'+quoteId+'/quote_items/'+quoteItemId)
            .then(results => {
                return results.json();
            }).catch(function() {
             return false;
            })
        return results;
    },

    async getQuoteItems(patternId){
        const attributes = await fetch(window.location.origin + '/api/v1/configurator/patterns/' + patternId + '?code=' + value)
            .then(results => {
                return results.json();
            })
        return attributes
    }

};

export default quoteItemApi;